import React from 'react';

const ChatLoader: React.FC = () => {
  const clientType = process.env.REACT_APP_CLIENT;

  const renderBrandLogo = () => {
    switch (clientType) {
      case 'salesbot2290ai':
        return (
          <div className="ai2290-brand-bg">
            <div className="ai2290-brand-icon"></div>
          </div>
        );

      case 'salesbottax1099':
        return (
          <div className="aitax1099-brand-bg">
            <div className="aitax1099-brand-icon"></div>
          </div>
        );
    }
    return <></>;
  };

  return (
    <div className="flex my-4 space-x-3 sm:w-11/12 w-full relative">
      {renderBrandLogo()}
      <div className="bg-[#F9F9F9] sm:p-4 p-2 rounded-r-lg rounded-bl-lg divide-neutral-900/10 w-full sm:w-10/12">
        <div className="flex items-start">
          <div className="inline-flex items-center gap-2 px-4 py-3 bg-[#FFFFFF] rounded-lg">
            <div className="flex gap-1">
              <span className="w-1 h-1 bg-gray-400 rounded-full animate-bounce [animation-delay:0ms]"></span>
              <span className="w-1 h-1 bg-gray-400 rounded-full animate-bounce [animation-delay:200ms]"></span>
              <span className="w-1 h-1 bg-gray-400 rounded-full animate-bounce [animation-delay:400ms]"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatLoader;
